import React from 'react';

export const DashboardExternalPage = () => {
    return (
        <iframe
            style={{ width: '100%', height: '100%' }}
            src={'/embed/dashboard'}
        />
    );
};
